import React from 'react';
import MultiStep from '../../../../tc-ui/stepper-wizard';
import StepOne from './1-step-offers.jsx';
import StepTwo from './2-step-offers.jsx';
import StepThree from './3-step-offers.jsx';

const StandardSpecialOffersContainer = ({ specialOffersStepper, RatesFormAndTable, updateCellValueForOfferRates, ...extraProps }) => {
  const stepNames = ['Offer Details', 'Rates', 'Dates & Review'];
  return (
    <MultiStep
      steps={stepNames}
      componentIndex={specialOffersStepper}
      showStepsBar
    >
      <StepOne {...extraProps} />
      <StepTwo {...extraProps} offerRates={RatesFormAndTable} />
      <StepThree
        {...extraProps}
        commissionPercentage={extraProps.data.commissionPercentage || RatesFormAndTable.commissionPercentage}
        rateType={extraProps.data.rateType || RatesFormAndTable.rateType}
        nettCommission={extraProps.data.nettCommission || RatesFormAndTable.nettCommission}
        currency={extraProps.data.currency || RatesFormAndTable.currency}
        taxInclusion={extraProps.data.taxInclusion || RatesFormAndTable.taxInclusion}
        taxType={extraProps.data.taxType || RatesFormAndTable.taxType}
        nonStandardTemplateType={extraProps.data.nonStandardTemplateType || RatesFormAndTable.nonStandardTemplateType}
        rates={extraProps.data.rates && extraProps.data.rates.length ? extraProps.data.rates : RatesFormAndTable.rates}
        updateTableCell={extraProps.data.rates && extraProps.data.rates.length ? ({ value, row, column }) => {
          extraProps.onTextFieldChangeWithKeyPath({ keyPath: ['data', 'rates', row, column], value });
        } : updateCellValueForOfferRates}
      />
    </MultiStep>);
};

export default StandardSpecialOffersContainer;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/special-offers/standard-offer-wizard.jsx